// extracted by mini-css-extract-plugin
module.exports =  {"slide":"_9330de7794--slide--_FOv0","slide-content":"_9330de7794--slide-content--eQWZf","image":"_9330de7794--image--dGtCz"};